import CashFormViewController from './CashFormViewController';

export default CashFormViewController;
